import React from "react";
import { FileText } from "lucide-react";

function TabSection({ tabs, current, msbName }) {

    return (
        <>
            {/* Render the active tab's content */}
            {tabs[current].render}

            {/* Rule Identifier card — only shown on the Rule tab (index 0) */}
            {current === 0 &&
                <div className="addrules-rule-id-v2">
                    <div className="rule-id-box">
                        <div className="rule-id-header">
                            <FileText />
                            <span>Rule Identifier</span>
                        </div>
                        <p className="rule-id-value">
                            {msbName || '—'}
                        </p>
                    </div>
                </div>
            }
        </>
    )

}

export default TabSection;
